import store from '../../../store/store';
import { PAYMENT_MESSAGE_ID, updateGlobalMessage } from '../../alert/global-message';
import { PaymentDetails } from '../../checkout/shop-checkout.interface';
import { StoreState } from '../../../store/store.interface';
import { getCart } from '../../cart/shop-cart/store/shop-cart.selectors';
import { getDigitalHandlingFees, getPaymentDetails, getTaxCalculation } from '../../checkout/shop-checkout';
import { hasOnlyFreeTrialProducts } from '../../../common/utils/cart-util';

export default class PaymentDetailsRequestBuilder {
  /**
   * Validates and returns the payment details.
   */
  build(): PaymentDetails | null {
    const state = store.getState() as StoreState;

    const cart = getCart(state);
    const digitalHandlingFees = getDigitalHandlingFees(state);
    const tax = getTaxCalculation(state);

    const hasOnlyFreeTrial = hasOnlyFreeTrialProducts(getCart(store.getState() as StoreState)?.products);
    const isMissingDetails = ((!tax || !digitalHandlingFees || !cart?.totalAmount) && !hasOnlyFreeTrial);
    const paymentDetails = getPaymentDetails(state);

    if (!paymentDetails?.paymentType || isMissingDetails) {
      this.dispatchPaymentError()
      return null;
    }

    return paymentDetails;
  }

  /**
   * Logs and dispatches an error when the payment details are missing.
   */
  private dispatchPaymentError() {
    console.error('Missing details to complete checkout');
    store.dispatch(updateGlobalMessage({
      type: PAYMENT_MESSAGE_ID,
      message: 'Missing details to complete checkout. Please try again.'
    }));
  }
}

